/* eslint-disable no-useless-catch */
import { Formatter } from 'Utils/Formatter'
import {
  ADD_TO_CART,
  ADD_BATCH_TO_CART,
  REMOVE_FROM_CART,
  ADD_ONE,
  ADD_MANY,
  REMOVE_ONE,
  SET_DISCOUNT,
  EMPTY_CART,
  UPDATE_CART_ITEM,
  SET_PENDING_ADD_PRODUCT_ID,
  IS_LOADING_ALL_PRODUCTS,
} from '../types'

import { getMarginTotal } from 'Utils/functions'
import { finalPrice } from 'api/mdl22'
import { getNextLineNum } from 'Utils/Helpers/getNextLineNum'
import {
  processWarranties,
  buildFinalProductsInOrder,
  formatFinalPriceData,
} from 'Components/ActionTable/hooks/checkFinalPriceUtils'

export const priceListAddToCart = (
  payload,
  CustomerId = null,
  contadoClient = false
) => {
  return async (dispatch, getState) => {
    const cart = getState().cart.cart
    const QuoteHeader = getState().cotizacion.QuoteHeader
    const { WarehouseId, CompanyId } = getState().company
    const PriceListId = QuoteHeader.PriceListId
    dispatch(isLoadingProduct({ isLoadingProduct: true }))

    const productList = payload.filter(p => !p.IsExtendedWarranty)
    const warrantyProducts = payload.filter(p => p.IsExtendedWarranty)
    const combinedPayload = productList.map(prod => ({
      product: prod,
      qty: prod.Quantity || prod.qty || 1,
      hashasDiscount: prod.BasePrice > prod.FinalPrice,
    }))

    let productAddedToCart = false

    try {
      const ProductIds = productList.map(product => product.ProductId)
      const payloadService = {
        CompanyId,
        WarehouseId,
        ProductIds,
        ...(CustomerId ? { CustomerId } : { PriceListId }),
      }

      const response = await finalPrice(payloadService)
      const { data, status } = response
      if (status === 200 && data?.Data) {
        const processedProducts = formatFinalPriceData(
          combinedPayload,
          data.Data
        )
        const processedWarranties = processWarranties(warrantyProducts)

        const finalOrderedProducts = buildFinalProductsInOrder(
          payload,
          processedProducts,
          processedWarranties
        )

        const cartItems = finalOrderedProducts.map(prod => ({
          product: getPayloadProduct(
            prod.selectList,
            prod.payload,
            prod.warehouse,
            prod.Quantity,
            prod.Price,
            false,
            cart
          ),
          qty: prod.qty,
        }))
        dispatch(addBatchToCart(cartItems))
        productAddedToCart = true
      }
    } catch (err) {
      console.error('priceListAddToCart error:', err)
    } finally {
      dispatch(isLoadingProduct({ isLoadingAllProducts: false }))
    }

    return productAddedToCart
  }
}

const getPayloadProduct = (
  selectList,
  payload,
  warehouse,
  Quantity,
  Price,
  isClone = false,
  cart = []
) => {
  const FinalPrice = selectList.FinalPrice

  const BasePrice = payload.product.BasePrice
  if (
    payload.product.NegotiatedReason !== null &&
    payload.product.NegotiatedReason
  ) {
    Price = payload.product?.Price
  }
  if (isClone) Price = FinalPrice
  const AmountWithTax =
    parseFloat(Price * payload.product.TaxCategoryValue + Price) * Quantity

  const Amount = parseFloat(Price) * Quantity
  const priceTotal = Formatter.Money(Amount, {
    withFormat: false,
    rounded: true,
    decimalPrecision: 2,
  })
  const DiscountAmount = BasePrice - Price < 0 ? 0 : BasePrice - Price
  const DiscountPct =
    ((BasePrice - Price) * 100) / Price < 0
      ? 0
      : ((BasePrice - Price) * 100) / Price

  const modifiedProduct = {
    ...payload.product,
    BasePrice,
    BasePriceLocal: BasePrice,
    FinalPrice,
    Price,
    Quantity,
    Tax: Number(Formatter.Money(priceTotal * payload.product.TaxCategoryValue)),
    Cost: payload.product.Cost || payload.product.AvgCost || 0.0,
    AmountWithTax,
    Amount: priceTotal,
    DiscountAmount,
    DiscountAmountLocal: DiscountAmount,
    DiscountPct,
    WarehouseId: warehouse.WarehouseId,
    WarehouseCode: warehouse.WarehouseCode,
    WarehouseDescription: warehouse.WarehouseDescription,
    WarehouseAddress: warehouse.WarehouseAddress,
    QuoteHeaderId:
      payload?.DocHeaderId || '00000000-0000-0000-0000-000000000000',
    NegotiatedPriceBy: payload.product?.NegotiatedPriceBy || null,
    NegotiatedPriceByName: payload.product?.NegotiatedPriceByName || null,
    NegotiatedReason: payload.product?.NegotiatedReason || null,
    NegotiatedReasonCode: payload.product?.NegotiatedReasonCode || null,
    NegotiatedReasonId: payload.product?.NegotiatedReasonId || null,
    Margin: getMarginTotal(
      Price,
      payload.product.Cost || payload.product.AvgCost || 0.0,
      Quantity
    ),
    AppliesForExtendedWarranty: payload.product?.AppliesForExtendedWarranty,
    AuthorizedPriceBy: payload.product?.AuthorizedPriceBy || null,
    AuthorizedPriceByName: payload.product?.AuthorizedPriceByName || null,
    BackOrder: payload.product?.BackOrder,
    CreatedBy: payload.product?.CreatedBy || null,
    CreatedDate: payload.product?.CreatedDate || null,
    DocLineId: payload.product?.DocLineId || null,
    FinalPriceList: FinalPrice,
    LineNum: payload.product?.LineNum || getNextLineNum(cart),
  }

  return modifiedProduct
}

export const buildWarrantyPayload = ({ warrantyProduct, selectedWarranty }) => {
  const price = selectedWarranty.CalculatedPrice

  return {
    Price: price,
    FinalPrice: price,
    product: {
      ...warrantyProduct,
      Price: price,
      BasePrice: price,
      FinalPrice: price,
      IsService: true,
      IsExtendedWarranty: true,
      WarrantyYears: selectedWarranty.WarrantyYears,
      WarrantyProductId: selectedWarranty.WarrantyProductId,
      WarrantyPercent: selectedWarranty.WarrantyPercent,
    },
  }
}

const addWarrantyToCart = (
  warrantyOption,
  warrantyData,
  parentProductId,
  warrantyQty = null
) => {
  return async (dispatch, getState) => {
    const state = getState()
    const cart = state.cart.cart
    const QuoteHeader = state.cotizacion.QuoteHeader
    dispatch(isLoadingProduct({ isLoadingProduct: true }))

    try {
      const { WarehouseId, WarehouseCode, WarehouseDescription } =
        getState().company
      const { WarehouseAddress } = QuoteHeader

      const warehouse = {
        WarehouseId,
        WarehouseCode,
        WarehouseDescription,
        WarehouseAddress,
      }

      const payloadBase = buildWarrantyPayload({
        warrantyProduct: warrantyData,
        selectedWarranty: warrantyOption,
      })

      // Determine actual quantity: use explicit qty (capped at product qty) or product qty
      const product = cart.find(
        item => item.ProductId === parentProductId && !item.IsExtendedWarranty
      )
      const productQty = product ? Number(product.Quantity) : 1
      const actualQty =
        warrantyQty != null ? Math.min(warrantyQty, productQty) : productQty

      const payload = {
        ...payloadBase,
        Quantity: actualQty,
      }

      const action = addToCart(
        getPayloadProduct(
          payload,
          payload,
          warehouse,
          actualQty,
          payload.FinalPrice,
          false,
          cart
        ),
        actualQty
      )

      dispatch(action)
    } catch (error) {
      console.error('Error adding warranty to cart:', error)
    } finally {
      dispatch(isLoadingProduct({ isLoadingProduct: false }))
    }
  }
}

const addToCart = (payload, qty) => ({
  type: ADD_TO_CART,
  payload: {
    product: payload,
    qty,
  },
})

const addBatchToCart = items => ({
  type: ADD_BATCH_TO_CART,
  payload: items,
})

const removeFromCart = payload => ({
  type: REMOVE_FROM_CART,
  payload,
})

const addOne = ({ product, newQuantity }) => ({
  type: ADD_ONE,
  payload: {
    product,
    newQuantity,
  },
})

const addMany = payload => ({
  type: ADD_MANY,
  payload,
})

const removeOne = ({ product, newQuantity }) => ({
  type: REMOVE_ONE,
  payload: {
    product,
    newQuantity,
  },
})
const setDiscount = payload => ({
  type: SET_DISCOUNT,
  payload,
})

const emptyCart = () => ({
  type: EMPTY_CART,
})

const isLoadingProduct = payload => ({
  type: IS_LOADING_ALL_PRODUCTS,
  payload,
})

const updateCartItem = ({
  productId = null,
  updatedFields,
  matchCriteria = null,
}) => ({
  type: UPDATE_CART_ITEM,
  payload: {
    productId,
    updatedFields,
    ...(matchCriteria && { matchCriteria }),
  },
})

const setPendingAddProductId = payload => {
  return {
    type: SET_PENDING_ADD_PRODUCT_ID,
    payload,
  }
}

const removeWarrantyFromCart = productId => (dispatch, getState) => {
  const cart = getState().cart.cart
  const warrantyItem = cart.find(
    item => item.IsExtendedWarranty && item.WarrantyProductId === productId
  )
  if (warrantyItem) {
    dispatch(removeFromCart({ product: warrantyItem }))
  }
}

export {
  addToCart,
  addBatchToCart,
  emptyCart,
  addMany,
  removeFromCart,
  addOne,
  removeOne,
  setDiscount,
  isLoadingProduct,
  getPayloadProduct,
  updateCartItem,
  setPendingAddProductId,
  addWarrantyToCart,
  removeWarrantyFromCart,
}
